export const TOGGLE_GRID_COLUMNS = "toggle_grid_columns";
export const TOGGLE_GRID_FILTERS = "toggle_grid_filters";
export const TOGGLE_GRID_OPTIONS = "toggle_grid_options";
export const HANDLE_PAGE_DATA = "handle_page_data";
